import { animateIn, animateOut } from '../utility/animate.js'
import { focusTrap } from "../utility/focusTrap"

function requestModal(el) {

    const body = document.querySelector('body')
    const requestButton = document.querySelector('.modal-button')
    const requestModalOverlay = el.querySelector('.modal__overlay')
    const requestClose = el.querySelector('.modal__close')
    const trapFocus = focusTrap(requestButton, el)

    let isActive = false

    function open() {
        isActive = true
        animateIn(el)
        body.classList.add('overflow-hidden')
        trapFocus.enter()
    }

    function close() {
        isActive = false
        animateOut(el)
        body.classList.remove('overflow-hidden')
        trapFocus.exit()
    }
    function toggle() {
        isActive ? close() : open()
    }

    requestButton.addEventListener("click", e => e.preventDefault());
    requestButton.addEventListener('click', toggle)
    requestModalOverlay.addEventListener('click', close)
    requestClose.addEventListener('click', close)


    // detect esc key
    window.addEventListener('keydown', event => {
        const escKey = (event.key === 'Escape' || event.keyCode === 27)
        const isActive = el.classList.contains('active')
        if (isActive && escKey) toggle()
    })
}


[...document.querySelectorAll('.request-modal')].map(requestModal)